/* eslint-disable react/no-unstable-nested-components */

import Image from 'next/image';
import React from 'react';
import { useTranslations } from 'next-intl';
import Divider from '@/components/Divider/Divider';
import LocaleSwitcher from '@/components/LocaleSwitcher/LocaleSwitcher';
import styles from './LoginWrapper.module.scss';
import SideHero from '@/components/SideHero/SideHero';
import { useShowLocaleSwitcher } from '@/hooks/useShowLocaleSwitcher';

interface ILoginWrapper {
  children: React.ReactNode;
  heading: string;
  subtitle: string;
}

const LoginWrapper = ({ children, heading, subtitle }: ILoginWrapper) => {
  const t = useTranslations('Login');
  const showLocale = useShowLocaleSwitcher();

  return (
    <div className={styles.page}>
      <div className={styles.container}>
        <main className={styles.left}>
          <div className={styles.formWrapper}>
            <div className={styles.top}>
              <div className={styles.logo}>
                <Image
                  src='/logo.svg'
                  alt='Art of You logo'
                  width={203}
                  height={38}
                  priority
                  className={styles.logoImg}
                />
              </div>
              {showLocale && <LocaleSwitcher />}
            </div>

            <h1 className={styles.heading}>{heading}</h1>
            <p className={styles.subtitle}>{subtitle}</p>

            <Divider />

            {children}
          </div>
        </main>

        <aside className={styles.right}>
          <SideHero
            hero={{
              imageSrc: '/login.png',
              imageAlt: t('Hero image'),
              title: t.rich('Empowering you to thrive', { linebreak: () => <br /> }),
            }}
          />
        </aside>
      </div>
    </div>
  );
};

export default LoginWrapper;
